import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Spacings, Fonts } from '@styles/index';
import Popper from '@material-ui/core/Popper';

export interface ITopicTooltipFn {
  onChapterHover: (event: any, educatorCoveredConcept: boolean) => void;
  onChapterLeave: () => void;
}

const TooltipWrapper = styled.div`
  background: var(--color-base-1);
  border: ${Spacings.SPACING_1} solid var(--color-divider);
  border-radius: ${Spacings.SPACING_1B};
  padding: ${Spacings.SPACING_1B};
`;

const Text = styled.p`
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.EXTRA_SMALL};
  line-height: 100%;
  text-transform: uppercase;
  color: var(--color-text-primary);
`;

// eslint-disable-next-line no-empty-pattern
const TopicTooltip = React.forwardRef<ITopicTooltipFn, {}>(({}, ref) => {
  React.useImperativeHandle(ref, () => ({ onChapterHover, onChapterLeave }));
  const [open, setOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = React.useState<HTMLDivElement>(null);

  const onChapterLeave = () => {
    setHoveredItem(null);
    setOpen(false);
  };

  const onChapterHover = (event, educatorCoveredConcept) => {
    if (!educatorCoveredConcept) {
      setHoveredItem(event.currentTarget);
      setOpen(true);
    }
  };

  return (
    <Popper open={open} anchorEl={hoveredItem} placement="bottom-end">
      <TooltipWrapper>
        <Text>Not covered by educator</Text>
      </TooltipWrapper>
    </Popper>
  );
});

TopicTooltip.displayName = 'TopicTooltip';
export default TopicTooltip;
